// Approved, edited Santurce night-market photograph used consistently across
// the neighborhood guide, district landing and homepage card.
export const SANTURCE_NIGHT_IMAGE = "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/4209cb38a_santurce_night_market_celebration.png";
export const neighborhoodCover = (name, fallback = "") =>
  String(name || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase() === "santurce"
    ? SANTURCE_NIGHT_IMAGE
    : fallback;
